<template>
  <div class="columns is-multiline">
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-content">
            <h3 class="is-size-3">Exportar excel</h3>
            <form class="has-text-left">
                <div class="card-content">
                    <h3 class="is-size-3"></h3>
                    <br>
                    <div class="columns is-multiline">
                    <b-field class="column is-6" label="Fundación">
                        <b-select v-model="filtro.fundation" class="mb-6" expanded>
                            <option :value="null" disabled>-- Please select an option --</option>
                            <option
                              v-for="fundation in fundations"
                              :value="fundation.id"
                              :key="fundation.id">
                              {{ fundation.name }}
                            </option>
                            <!-- <option value="FUENTE">Retencion en la fuente</option><option value="ICA">Retencion por ica</option> -->
                        </b-select>
                    </b-field>
                    <b-field class="column is-6" label="Retención">
                        <b-select v-model="filtro.retentation" class="mb-6" expanded>
                            <option :value="null">-- Please select an option --</option>
                            <option value="FUENTE">RETENCION EN LA FUENTA</option><option value="ICA">RETENCION POR ICA</option>
                        </b-select>
                    </b-field>
                    <b-field class="column is-6" label="Proveedor">
                        <b-autocomplete
                          v-model="filtro.proveedor"
                          :keep-first="true"
                          :open-on-focus="false"
                          :data="filteredData"
                          field="name"
                          @select="option => selected = option">
                        </b-autocomplete>
                    </b-field>
                    <b-field class="column is-6" label="Fecha">
                      <b-input placeholder="Number"
                        type="number"
                        min="2010"
                        v-model="filtro.año">
                      </b-input>
                    </b-field>
                    <b-field class="column is-6" label="Archivo">
                        <b-autocomplete
                          v-model="filtro.archive"
                          :keep-first="true"
                          :open-on-focus="false"
                          :data="filteredDataArchive"
                          field="archive_name"
                          @select="option => selected = option">
                        </b-autocomplete>
                    </b-field>
                    <b-field class="column is-6" label="Municipio">
                      <b-select v-model="filtro.municipality" class="mb-6" expanded>
                          <option :value="null">-- Please select an option --</option>
                          <option value="CALI">Cali</option><option value="JAMUNDI">Jamundi</option><option value="YUMBO">Yumbo</option>
                      </b-select>
                    </b-field>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="button" class="button is-warning is-radiusless" @click="submit()">Enviar</button>
                    <button type="button" class="button is-default is-radiusless" @click="goTo('user')">Cancelar</button>
                </div>
            </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import OutputsService from '@/services/OutputsService'
import env from '@/env'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
  },
  data () {
    return {
      date: new Date(),
      filtro: {
        fundation: null,
        retentation: null,
        proveedor: '',
        año: null,
        archive: '',
        municipality: null
      },
      table: {
        data: []
      },
      transactions: [],
      archives: [],
      fundations: []
    }
  },
  computed: {
    filteredData () {
      return this.transactions.filter((option) => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(this.filtro.proveedor.toLowerCase()) >= 0
      })
    },
    filteredDataArchive () {
      return this.archives.filter((option) => {
        return option.archive_name
          .toString()
          .toLowerCase()
          .indexOf(this.filtro.archive.toLowerCase()) >= 0
      })
    }
  },
  mounted () {
    this.fetchTransaction()
    this.fetchArchive()
    this.fetchFundation()
    this.fetchData()
  },
  methods: {
    async fetchData () {
      var outputs = []
      if (this.admin) {
        outputs = await OutputsService.fetchOutputs(this.$session.get('user').token)
      } else {
        outputs = await OutputsService.fetchOutputs2(this.id, this.$session.get('user').token)
      }

      for (var i = 0; i < outputs.data.length; i++) {
        this.table.data.push(outputs.data[i])
      }
    },
    async fetchTransaction () {
      var transactions = await OutputsService.fetchTransactions(this.$session.get('user').token)
      this.transactions = transactions.data
    },
    async fetchArchive () {
      var archive = await OutputsService.fetchArchives(this.$session.get('user').token)
      this.archives = archive.data
    },
    async fetchFundation () {
      var fundations = await OutputsService.fetchFundations(this.$session.get('user').token)
      this.fundations = fundations.data
    },
    async submit () {
      var pro = null
      var arc = null
      if (this.filtro.proveedor !== '') {
        pro = this.filtro.proveedor
      }
      if (this.filtro.archive !== '') {
        arc = this.filtro.archive
      }
      window.open(env.API_BASE_URL + '/outputs/EXCEL/' + this.filtro.fundation + '/' + this.filtro.retentation + '/' + pro + '/' + this.filtro.año + '/' + arc + '/' + this.filtro.municipality, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/output/OutputExcel.vue